import ResponsiveImage from '@/components/ResponsiveImage';

const BackgroundImage = props => {
  return (
    <>
      <div
        className='w-full min-h-screen absolute inset-y-0 -z-20 -left-4'
        style={{ backgroundImage: 'linear-gradient(90deg, #030314 43.54%, rgba(3, 3, 20, 0.00) 70.05%)' }}
      />
      <div
        className='w-80 min-h-screen absolute inset-y-0 -z-20 -right-4'
        style={{ backgroundImage: 'linear-gradient(-90deg, #030314 4.61%, rgba(3, 3, 20, 0.00) 70.05%)' }}
      />
      <div className='spotlight-background-image media absolute -z-30 inset-y-0 w-full'>
        <ResponsiveImage file={props} priority fill className='object-cover object-right' />
      </div>
    </>
  );
};

export default BackgroundImage;
